import gsap from "gsap";

export default class LoadAnimations {

    constructor() {
        this.init();
    }

    init() {

        this.animationElements = document.querySelectorAll(".js-animation-element");

        if (this.animationElements.length < 1) {
            return;
        }

        gsap.fromTo(this.animationElements,
            {
                autoAlpha: 0,
                y: 20,
            },
            {
                autoAlpha: 1,
                y: 0,
                duration: 0.5,
                stagger: 0.2,
                delay: 0.6,
            });

    }

}
